/**
 * Match Me
 *
 * Controls step navigation, region selection, preference selection,
 * keyboard focus, and form submission for the Match Me workflow.
 */
$(document).on("ready", function () {
  if (!$("#matchme").length) {
    return;
  }

  $(".prev").hide();

  /**
   * Moves programmatic focus to the active Match Me step so keyboard and
   * screen-reader users receive the newly displayed step context.
   */
  function focusActiveStep(stepIndex) {
    var $activeStep = $("#action" + stepIndex);

    $activeStep.trigger("focus");
  }

  /**
   * Returns keyboard-focusable controls contained within the currently
   * displayed Match Me step.
   *
   * Prev and Next are intentionally excluded because they are shared
   * navigation controls and are placed after the active step controls
   * through the keyboard handling below.
   */
  function getActiveStepControls() {
    return $(".action.current")
      .find(
        'a[href], ' +
        'button:not([disabled]), ' +
        'input:not([type="hidden"]):not([disabled]), ' +
        'select:not([disabled]), ' +
        'textarea:not([disabled]), ' +
        '[role="button"][tabindex="0"], ' +
        '[tabindex="0"]'
      )
      .filter(":visible")
      .not(".prev, .next");
  }

  /**
   * Moves to the next Match Me step and places focus on the newly
   * displayed step.
   */
  $(".next").on("click", function (e) {
    e.preventDefault();

    var cur = parseInt(
      $(".action.current").attr("id").replace("action", ""),
      10
    );

    if (cur < 3) {
      var nxt = cur + 1;

      $(".action, .blurb").removeClass("current");
      $("#action" + nxt + ", #blurb" + nxt).addClass("current");

      if (nxt === 0) {
        $(".prev").hide();
      } else {
        $(".prev").show();
      }

      if (nxt === 3) {
        $(".next").hide();
      } else {
        $(".next").show();
      }

      $("#c" + nxt).addClass("complete");

      focusActiveStep(nxt);
    }
  });

  /**
   * Moves to the previous Match Me step and places focus on the newly
   * displayed step.
   */
  $(".prev").on("click", function (e) {
    e.preventDefault();

    var cur = parseInt(
      $(".action.current").attr("id").replace("action", ""),
      10
    );

    if (cur > 0) {
      var nxt = cur - 1;

      $(".action, .blurb").removeClass("current");
      $("#action" + nxt + ", #blurb" + nxt).addClass("current");

      if (nxt === 0) {
        $(".prev").hide();
      } else {
        $(".prev").show();
      }

      if (nxt === 3) {
        $(".next").hide();
      } else {
        $(".next").show();
      }

      $("#c" + cur).removeClass("complete");

      focusActiveStep(nxt);
    }
  });

  /**
   * Places the shared Prev and Next controls after the active step's
   * controls in the keyboard sequence while preserving their visual
   * position in the left column.
   *
   * Expected forward order:
   * active step controls -> Prev when available -> Next when available.
   *
   * Expected reverse order:
   * Next -> Prev when available -> last active step control.
   */
  $(document).on("keydown", function (e) {
    if (e.key !== "Tab") {
      return;
    }

    var $activeStep = $(".action.current");
    var $controls = getActiveStepControls();
    var $prev = $(".prev:visible");
    var $next = $(".next:visible");
    var $target = $(e.target);

    var $first = $controls.first();
    var $last = $controls.last();

    /**
     * Programmatic focus is placed on the active step after Prev or Next
     * is activated. Forward Tab enters the step's controls before reaching
     * the shared navigation controls.
     */
    if (!e.shiftKey && $target.is($activeStep)) {
      e.preventDefault();

      if ($first.length) {
        $first.trigger("focus");
      } else if ($prev.length) {
        $prev.trigger("focus");
      } else if ($next.length) {
        $next.trigger("focus");
      }

      return;
    }

    /**
     * Forward Tab from the final control in the active step moves to Prev
     * when available, followed by Next.
     */
    if (
      !e.shiftKey &&
      $last.length &&
      $target.is($last)
    ) {
      if ($prev.length) {
        e.preventDefault();
        $prev.trigger("focus");
      } else if ($next.length) {
        e.preventDefault();
        $next.trigger("focus");
      }

      return;
    }

    /**
     * Forward Tab from Prev continues to Next when Next is displayed.
     */
    if (
      !e.shiftKey &&
      $target.is($prev) &&
      $next.length
    ) {
      e.preventDefault();
      $next.trigger("focus");

      return;
    }

    /**
     * Reverse Tab from Next moves to Prev when available. On the first
     * step, where Prev is hidden, focus returns to the last step control.
     */
    if (
      e.shiftKey &&
      $target.is($next)
    ) {
      e.preventDefault();

      if ($prev.length) {
        $prev.trigger("focus");
      } else if ($last.length) {
        $last.trigger("focus");
      } else {
        $activeStep.trigger("focus");
      }

      return;
    }

    /**
     * Reverse Tab from Prev returns to the final control in the active
     * step.
     */
    if (
      e.shiftKey &&
      $target.is($prev)
    ) {
      e.preventDefault();

      if ($last.length) {
        $last.trigger("focus");
      } else {
        $activeStep.trigger("focus");
      }
    }
  });

  /**
   * Maintains a shared selected state for both visual representations of
   * each region and exposes that state through the accessible control.
   */
  function toggleRegion($region) {
    var which = $region.attr("data-which");

    var $matchingRegions = $(
      '.region[data-which="' + which + '"]'
    );

    var $accessibleRegion = $matchingRegions.filter(
      '[role="button"]'
    );

    var isActive =
      $accessibleRegion.attr("aria-pressed") !== "true";

    $matchingRegions.toggleClass("active", isActive);

    $accessibleRegion.attr(
      "aria-pressed",
      isActive ? "true" : "false"
    );

    /**
     * Maintains the comma-separated Region value expected by the
     * college search request.
     */
    $("#State").val("");

    $("#action0 td.region.active").each(function () {
      $("#State").val(
        $("#State").val() +
        $(this).attr("data-which") +
        ","
      );
    });
  }

  /**
   * Supports pointer activation from either visual representation of
   * a region.
   */
  $(".region").on("click", function () {
    toggleRegion($(this));
  });

  /**
   * Supports standard Enter and Space activation for the accessible
   * region controls.
   */
  $("#action0 td.region[role='button']").on(
    "keydown",
    function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();

        toggleRegion($(this));
      }
    }
  );

  /**
   * Maintains school-size selection state and synchronizes the visual
   * controls with their associated checkbox values.
   */
  $("#action1 div").on("click", function () {
    var sz = $(this).attr("id");

    if (sz === "sizenp") {
      $("div.size.active").each(function () {
        document.getElementById(
          $(this).attr("data-which")
        ).checked = false;
      });

      $("#action1 div").removeClass("active");
    } else {
      $("#" + sz).toggleClass("active");
    }
  });

  /**
   * Maintains campus-setting selection state, including the
   * No Preference option.
   */
  $("#action2 div").on("click", function () {
    var sz = $(this).attr("id");

    if (sz === "settingnp") {
      $("#action2 div").removeClass("active");
    } else {
      $("#" + sz).toggleClass("active");
    }
  });

  /**
   * Provides a change-event hook for the final Match Me step controls.
   */
  $("#action3 input, #action3 select").on(
    "change",
    function () {}
  );

  /**
   * Adds the selected study focus to the submitted form data before
   * submitting the Match Me search.
   */
  $(document).on("click", ".mmsasubmit", function (e) {
    e.preventDefault();

    $("#matchForm").append(
      $("#StudyFocus").clone().hide()
    );

    $("#matchForm").submit();
  });

  /**
   * Provides Space-key activation for the Match Me submit control.
   */
  $(document).on(
    "keydown",
    ".mmsasubmit",
    function (e) {
      if (e.key === " ") {
        e.preventDefault();

        $(this).trigger("click");
      }
    }
  );
});